import React from 'react'
import { NavLink } from 'react-router-dom'

import './UpgradeToPremiumLink.scss'

type Props = {
  label?: string
  className?: string
}

const DEFAULT_LABEL = 'Upgrade to Premium'

const UpgradeToPremiumLink = ({ label = DEFAULT_LABEL, className }: Props) => (
  <NavLink to='/get-premium' className={['upgrade-sidebar-link', className].filter(Boolean).join(' ')}>
    <span className='upgrade-sidebar-link__inner'>
      <span className='upgrade-sidebar-link__spark' aria-hidden>
        ✦
      </span>
      <span>{label}</span>
    </span>
  </NavLink>
)

export default UpgradeToPremiumLink
